import type { Authorizations } from "~/api/types";

/** Extract `authorizations` from any API response whose generated type doesn't include the field. */
export const extractAuthorizations = (
  data: unknown,
): Authorizations | undefined => {
  if (data && typeof data === "object" && "authorizations" in data) {
    return (data as { authorizations: Authorizations }).authorizations;
  }

  return undefined;
};

export const canCollection = (
  authorizations: Authorizations | null | undefined,
  action: string,
): boolean => authorizations?.collection?.includes(action) ?? false;

/** Single-resource endpoints return `member` as a flat `string[]`. */
export const canMember = (
  authorizations: Authorizations | null | undefined,
  action: string,
): boolean =>
  ((authorizations?.member as unknown as string[]) ?? []).includes(action);

/** Collection endpoints return `member` as `string[][]` (per-row). */
export const canCollectionMember = (
  authorizations: Authorizations | null | undefined,
  index: number,
  action: string,
): boolean => authorizations?.member?.[index]?.includes(action) ?? false;
